const PARTICIPANT_HOME_PATHNAME = "/participant/home/";
const LOCAL_PCAP_API_PATHNAME = "/participant/home/?pcapApi=local/";
const PARTICIPANT_ACCOUNT_PATH = "/participant/accounts/";
const LOCAL_PCAP_API_PARTICIPANT_ACCOUNT = "/participant/accounts/?pcapApi=local/";

const mocksContainedInWithQuery = (str, query) => {
    return str.indexOf(query) > -1;
};

export const hasMocks = () => {
    const query = "useMocks=true";
    const { hash, search } = window.location;

    return mocksContainedInWithQuery(search, query) || mocksContainedInWithQuery(hash, query);
};

export const isLocalhost = () => String(window.location.href).indexOf("localhost") > -1;

export const islocalMocksTrue = () => isLocalhost() && hasMocks();
export const localMocksTrue = islocalMocksTrue();
export const islocalMocksFalse = () => isLocalhost() && !hasMocks();
export const localMocksFalse = islocalMocksFalse();

export const localPcapApi = __LOCAL_PCAP_API__ === "true";

const pcapBundle = () => String(window.location.href).indexOf("pcapBundle") > -1;
export const pcapBundleEnv = pcapBundle();

// Ensure the pcapApi=local search in url persists, allowing devs to more seamlessly navigate - useful for local development purposes
export const injectPcapApiParam = (str) => {
    if (localMocksFalse && localPcapApi) {
        // this can also be use when testing google analytics logs (logEvents=true)
        if (str.includes(PARTICIPANT_HOME_PATHNAME)) {
            return str.replace(PARTICIPANT_HOME_PATHNAME, LOCAL_PCAP_API_PATHNAME);
        }
        if (str.includes(PARTICIPANT_ACCOUNT_PATH)) {
            return str.replace(PARTICIPANT_ACCOUNT_PATH, LOCAL_PCAP_API_PARTICIPANT_ACCOUNT);
        }
    }
    return str;
};

// https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
export function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

// takes location object and returns custom string
export const getLocation = ({ host, href }) => {
    const location = href.slice(href.indexOf(host) + host.length + 1);
    return location;
};
